import {
  ANNOUNCEMENT_FONTS as F,
  ANNOUNCEMENT_PALETTE as P,
  announcementButtonBase,
  type AnnouncementCardProps,
} from '../announcement-style';

const STYLES = `
@keyframes announcementCardIn {
  from { opacity: 0; transform: translateY(14px) rotate(-0.5deg); }
  to { opacity: 1; transform: translateY(0) rotate(-0.5deg); }
}
`;

/**
 * "Clássico" — the original wheat-pasted cream card (tape strip on top,
 * slight tilt, Oswald headline, serif body). Kept pixel-for-pixel from the
 * first version of the gate so untouched announcements look as they always did.
 */
export function ClassicCard(props: AnnouncementCardProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={props.title}
      onClick={(event) => event.stopPropagation()}
      style={{
        position: 'relative',
        maxWidth: 560,
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        background: P.paper,
        border: `1px solid ${P.lightBorder}`,
        borderRadius: 3,
        padding: '34px 30px 28px',
        transform: 'rotate(-0.5deg)',
        boxShadow: '6px 10px 32px rgba(120, 40, 40, 0.18)',
        animation: props.reducedMotion ? undefined : 'announcementCardIn .35s ease both',
      }}
    >
      <style>{STYLES}</style>

      {/* Tape strip — wheat-pasted poster affordance */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: -6,
          left: '50%',
          width: 72,
          height: 13,
          background: 'rgba(212,25,32,0.1)',
          transform: 'translateX(-50%) rotate(-2deg)',
          backdropFilter: 'blur(1px)',
        }}
      />

      <h2
        style={{
          fontFamily: F.cond,
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: 20,
          letterSpacing: '.04em',
          lineHeight: 1.25,
          color: P.darkText,
          margin: 0,
        }}
      >
        {props.title}
      </h2>

      {props.body && (
        <p
          style={{
            fontFamily: F.serif,
            fontSize: 15,
            lineHeight: 1.65,
            color: P.midText,
            whiteSpace: 'pre-line',
            margin: '12px 0 0',
          }}
        >
          {props.body}
        </p>
      )}

      {props.media && <div style={{ marginTop: 18 }}>{props.media}</div>}

      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10, marginTop: 22 }}>
        <button
          ref={props.primaryRef}
          type="button"
          disabled={props.primaryDisabled}
          onClick={props.onPrimary}
          style={{
            ...announcementButtonBase,
            padding: '0 26px',
            background: P.maxRed,
            color: P.white,
            opacity: props.primaryDisabled ? 0.45 : 1,
            cursor: props.primaryDisabled ? 'default' : 'pointer',
          }}
        >
          {props.primaryLabel}
        </button>

        {props.skippable && (
          <button
            type="button"
            onClick={props.onSkip}
            style={{
              ...announcementButtonBase,
              padding: '0 26px',
              background: 'transparent',
              color: P.warmGray,
              borderColor: P.lightBorder,
            }}
          >
            {props.skipLabel}
          </button>
        )}
      </div>

      {props.gatedHint && (
        <p style={{ fontFamily: F.serif, fontStyle: 'italic', fontSize: 13, color: P.midText, margin: '10px 0 0' }}>
          {props.gatedHint}
        </p>
      )}
    </div>
  );
}
